import { render, staticRenderFns } from "./CmgCustomerGreeting.vue?vue&type=template&id=6b4b6772&scoped=true&lang=pug&"
import script from "./cmg-customer-greeting.ts?vue&type=script&lang=ts&"
export * from "./cmg-customer-greeting.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCustomerGreeting.vue?vue&type=style&index=0&id=6b4b6772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b6772",
  null
  
)

export default component.exports